import { FC, PropsWithChildren } from 'react';

export const SearchModalLabel: FC<PropsWithChildren> = ({ children }) => {
  return (
    <h3 className="text-xs font-bold text-gray-500 uppercase">{children}</h3>
  );
};
